/* eslint-disable @next/next/no-img-element */
import cn from "clsx";
import styles from "../reviews.module.scss";
import RatingDisplay from "./ratingDisplay";
import CommentBottomOpts from "./commentBottomOpts";
import Pagination from "@/app/csr-src/pages/order/components/pagination";
import PreviewImageVideo from "@/app/csr-src/components/previewImageVideo";
import  VideoPay  from "@/app/csr-src/components/videoDom/icons/videoPay_top.svg";
import InfoIcon from "@/app/csr-src/assets/icons/InfoIcon.svg";
import WarningIcon from "@/app/csr-src/assets/icons/WarningIcon.svg";

import { imageUtil } from "@/common-components-src/js/utils/imageUtil";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";
import UKPageNothing from "@/common-components-src/components/UKPageNothing";
import IntlDialog from "@/common-components-src/js/reviews/dialog";
import ReveiwDetailList from "@/common-components-src/js/reviews/reviewDetailList";

import { useState, useEffect, useLayoutEffect } from "react";
import { ReviewedRes, ReviewDetailItem, ReviewTipType } from "@/app/csr-src/apis/profile/review.interface";
import { fetchUserCommentedList, fetchUserReviewDetail } from "@/app/csr-src/apis/profile/review.api";
import { sendClickTrack as myReviewSendClickTrack, EXPOSURE_RECORD as MY_REVIEW_EXPOSURE_RECORD } from "@/tracks/25155";
import UKToast from "@/components/UKToast";


interface FetchReviewDetailParams {
  parentReplyId: string | number;
  skuId: string;
  commentId: string;
}
export default function ReviewComplete({ skuIdListFn }: any) {
  const [paginationData, setPaginationData] = useState<{ currentPage: number; pageSize: number }>({
    currentPage: 1,
    pageSize: 10,
  });
  const [lists, setLists] = useState<ReviewedRes[]>();
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenReviewDetail, setIsOpenReviewDetail] = useState<boolean>(false);
  const [reviewDetailData, setReviewDetailData] = useState<ReviewDetailItem | null>(null);
  const [detailCurrentSkuId, setDetailCurrentSkuId] = useState<string>("");
  const [isOpenReviewImage, setIsOpenReviewImage] = useState<boolean>(false);
  const [currentImageUrl, setCurrentImageUrl] = useState<string>("");
  const [urlList, setUrlList] = useState<any[]>([]);
  const [title, setTitle] = useState<string>("");
  const [content, setContent] = useState<string>("");
  const [reportCommentParams, setReportCommentParams] = useState<any>(null);

  const pagesChangeHandler = (page: number) => {
    window.scrollTo(0, 0); // 滚动到顶部
    const params = { ...paginationData };
    params.currentPage = page;
    setPaginationData(params);
  };
  const init = async () => {
    setIsLoading(true);
    const res = await fetchUserCommentedList(paginationData);
    setTotal(res?.total ?? 0);
    setLists(res?.data ?? []);
    if (res?.data && res?.data?.length > 0) {
      const skuIdList: any = res?.data.map((item: any, index: number) => {
        if (index <= 10 && item.skuId) {
          return item.skuId;
        }
      });
      skuIdListFn?.(skuIdList.join(","));
    } else {
      skuIdListFn?.("");
    }
    setIsLoading(false);
  };

  const handleReviewDetail = async (params: FetchReviewDetailParams) => {
    const res = await fetchUserReviewDetail(params);
    setIsOpenReviewDetail(true);
    setDetailCurrentSkuId(params.skuId);
    setReviewDetailData(res?.data || null);
    // onComment?.(res?.data || null);
    // setReviewDetailData(res?.data || null);
    // setCurrentOpenDetailReqParams(params);
    // setIsOpenReviewDetail(true);
  };
  const closeReviewImage = () => {
    setIsOpenReviewImage(false);
  };
  useEffect(() => {
    init();
  }, [paginationData]);

  const onAnonymousChange = (b: boolean, props: any) => {
    setLists(
      lists?.map((item: any) =>
        item.commentId == props?.commentId
          ? {
              ...item,
              ...props,
              anonymousFlag: b,
              userNickName: props.nickName,
            }
          : item,
      ),
    );
    init();
  };

  // 删除评价
  const reviewFooterCountyFn = (type: string, params: any) => {
    if (type === "previewDelete") {
      const { commentId } = params;
      setLists(lists?.filter((item: ReviewedRes) => item.commentId !== commentId));
      init();
    }
  };

  useLayoutEffect(() => {
    const scrollPosition = localStorage.getItem('scrollPosition');
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      localStorage.removeItem('scrollPosition');
    }
  }, [lists]);

  function imageVideoContent(item: ReviewedRes, key: number){
    return (
      <div className={styles.mediaZone}>
        {item?.videoList?.map((_, index) => (
          <div key={index}>
            {_.videoUrl && (
              <div
                key={index}
                style={{ width: "140px", height: "140px", position: "relative" }}
              >
                <video
                  style={{
                    width: "140px",
                    height: "140px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  src={_.videoUrl ? _.videoUrl : ""}
                  onClick={(e) => {
                    myReviewSendClickTrack.My_Reviews_Picture({material_type: "2", commentId: String(item?.commentId) || "-100" });
                    e.stopPropagation();
                    setIsOpenReviewImage(true);
                    setCurrentImageUrl(_.videoUrl);
                    setTitle(item?.nickName);
                    setContent(item?.content);
                    setReportCommentParams(item);
                    setUrlList([
                      ...(item?.videoList || []).map((item: any) => ({
                        type: 0,
                        url: item.videoUrl,
                      })),
                      ...(item?.imageList || []).map((item: any) => ({
                        type: 1,
                        url: item.imageUrl,
                      })),
                    ]);
                  }}
                ></video>
                <VideoPay style={{ position: "absolute", top: "10px", left: "10px" }} />
              </div>
            )}
          </div>
        ))}
        {item?.imageList?.map((_, index) => (
          <div key={index + key}>
            {_.imageUrl && (
              <img
                key={index + key}
                src={imageUtil.concatImgUrlWithoutForceHttps(_?.imageUrl, 140, 0, 100)}
                width={140}
                height={140}
                alt=""
                onClick={(e) => {
                  myReviewSendClickTrack.My_Reviews_Picture({material_type: "1", commentId: String(item?.commentId) || "-100" });
                  e.stopPropagation();
                  setIsOpenReviewImage(true);
                  setCurrentImageUrl(_?.imageUrl);
                  setTitle(item?.nickName);
                  setContent(item?.content);
                  setReportCommentParams(item);
                  setUrlList([
                    ...(item?.videoList || []).map((item: any) => ({
                      type: 0,
                      url: item.videoUrl,
                    })),
                    ...(item?.imageList || []).map((item: any) => ({
                      type: 1,
                      url: item.imageUrl,
                    })),
                  ]);
                }}
              />
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={styles.reviewCompletedWrapper}>
      {isLoading && <UKPageLoading />}
      {!isLoading && !lists?.length && (
        <div className={styles.pageEmpty}>
          <UKPageNothing text="There's nothing more" />
        </div>
      )}
      {!isLoading && (
        <div className={styles.reviewListBlock}>
          {lists?.map((item: ReviewedRes, key) => {
            return (
                <div
                  className={styles.reviewsItemBlock}
                  key={key}
                  /** 已完成评价tab下评价曝光 */
                  exptag={"exp|" + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_Completed_ReviewsList}
                  data-exptag-json-param={JSON.stringify({ orderId: item?.orderId ? item?.orderId : "-100", skuId: item.skuId, commentId: item.commentId })}
                  data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                  onClick={() => {
                      if(item && item.tipType === 2){
                        UKToast.show({
                            content: "This review has been reported and is no longer accessible.",
                            icon: "warning",
                        })
                        return;
                      }
                      handleReviewDetail({
                        skuId: item.skuId,
                        parentReplyId: item.parentReplyId || 0,
                        commentId: item.commentId,
                      })
                    }
                  }
                >
                  {
                    item?.tipDescription && (
                      <div className={styles.reviewItemTip}>
                        {item?.tipType == ReviewTipType.Normal ? <InfoIcon /> : <WarningIcon />}
                        <span className={styles.reviewItemTipText}>{item?.tipDescription}</span>
                      </div>
                    )
                  }
                  <div className={styles.product}>
                    <div className={styles.imgWrapper}>
                      {item.skuImage && (
                        <img
                          src={imageUtil.concatImgUrlWithoutForceHttps(item.skuImage, 60, 60, 70)}
                          alt=""
                        />
                      )}
                    </div>
                    <div className={styles.productContent}>
                      <div className={cn(styles.title, styles.lineOverflow)}>{item.skuTitle}</div>
                      <div className={styles.dimensions}>{item.propertyExt}</div>
                    </div>
                  </div>
                  <div className={styles.sectionScore}>
                    <RatingDisplay
                      value={item.star}
                      hiddenScoreNum
                      extra={<span>{item.commentDate}</span>}
                    />
                  </div>
                  <p className={cn(styles.basicFont, styles.reviewsContent)}>{item?.visible ? item?.content : item?.invisibleDescription }</p>
                  { item && item.tipType === ReviewTipType.Normal && imageVideoContent(item, key) }
                
                <CommentBottomOpts
                  pageType="reviewComment"
                  commentItem={item}
                  onComment={() => {
                    handleReviewDetail({
                      skuId: item.skuId,
                      parentReplyId: item.parentReplyId || 0,
                      commentId: item.commentId,
                    });
                  }}
                  onRefresh={init}
                />
                
                </div>
            );
          })}
        </div>
      )}
      <PreviewImageVideo
        isContent={true}
        nickName={title}
        content={content}
        urlList={urlList}
        open={isOpenReviewImage}
        imageUrl={currentImageUrl}
        closeView={closeReviewImage}
        reportCommentParams={{ currentUserOperation: true, ...reportCommentParams }}
        reviewFooterCountyFn={reviewFooterCountyFn}
      />
      {/* Review Detail */}
      <IntlDialog
        onClose={() => setIsOpenReviewDetail(false)}
        open={isOpenReviewDetail}
        title="Review"
        content={
          <ReveiwDetailList
            lists={reviewDetailData ? [reviewDetailData] : []}
            skuId={detailCurrentSkuId}
            onRefresh={init}
            onClose={() => setIsOpenReviewDetail(false)}
            onAnonymousChange={onAnonymousChange}
          />
        }
        width={800}
      />
      {total ? (
        <div className={styles.pagination_wrap}>
          <Pagination
            currentPage={paginationData.currentPage}
            totalPages={Math.ceil(total / paginationData.pageSize)}
            handlePageChange={pagesChangeHandler}
          />
        </div>
      ) : null}
    </div>
  );
}
